import React from "react";
import GenericList from "../../components/lists/GenericList";
import { listQaAssist } from "../../actions/qa-assist/listQaAssist";

const QaAssistList: React.FC<{
  refresh: boolean;
  onRefreshComplete: () => void;
}> = ({ refresh, onRefreshComplete }) => {
  return (
    <GenericList
      fetchData={listQaAssist}
      refresh={refresh}
      onRefreshComplete={onRefreshComplete}
    />
  );
};

export default QaAssistList;
